"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const react_1 = __importDefault(require("react"));
const Row = ({ style, className, children, rowOnMouseLeave, rowOnMouseEnter, ...rest }) => (react_1.default.createElement("div", { style: style, onMouseLeave: rowOnMouseLeave || undefined, onMouseEnter: rowOnMouseEnter || undefined, className: className, ...rest }, children));
exports.Row = Row;
